/**
 * Logger service for application-wide logging
 * - Development: Logs all messages to console
 * - Production: Only logs errors (warnings and info are no-ops)
 */
import * as Sentry from "@sentry/react";

export const logger = {
  /**
   * Log informational messages (dev only)
   */
  log: (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
      console.log(...args);
    }
  },

  /**
   * Log warning messages (dev only)
   */
  warn: (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
      console.warn(...args);
    }
  },

  /**
   * Log error messages (always logged, even in production)
   * Errors are also reported to Sentry when initialized.
   */
  error: (...args: unknown[]): void => {
    console.error(...args);
    // Send first Error instance to Sentry; fall back to message capture
    const errorObj = args.find((a): a is Error => a instanceof Error);
    if (errorObj) {
      Sentry.captureException(errorObj);
    } else if (args.length > 0) {
      Sentry.captureMessage(String(args[0]), "error");
    }
  },
};

